import clsx from "clsx";
import { Account } from "@/entities/DataAssociation/Account.model";
import { AccountItem } from "./AccountItem";

export function AccountList({
    accounts,
    recommendedIds = [],
    onAccountSelection,
}: {
    accounts: Account[];
    recommendedIds?: string[];
    onAccountSelection: (account: Account) => void;
}) {
    return (
        <ul
            className={clsx(
                "pb-4",
                "hide-scrollbar flex flex-1 flex-col gap-1 overflow-y-auto",
            )}
            role="list"
        >
            {accounts?.map((account) => (
                <AccountItem
                    key={account.id}
                    account={account}
                    recommended={recommendedIds.includes(account.id)}
                    onAccountSelection={onAccountSelection}
                />
            ))}
            {accounts.length === 0 && (
                <li className="text-subdued body-s text-center">
                    No accounts exist for this category.
                </li>
            )}
        </ul>
    );
}
